module.exports = __webpack_public_path__ + "static/img/5.2e7600c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/2/eng/5.png
// module id = 9YLy
// module chunks = 0